export default __webpack_public_path__ + "static/media/close.81442c21.svg";